module.exports = __webpack_public_path__ + "img/alexZiv.5f905b78.png";